"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentText = exports.ContentHeader = exports.LoadingCell = exports.Container = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const styles_1 = require("../../../../components/Shimmer/styles");
const SHIMMER_LINE_HEIGHT = '2rem';
exports.Container = (0, styled_1.default)('div') `
  width: 100%;
  height: 100%;
`;
exports.LoadingCell = (0, styled_1.default)(styles_1.ShimmerBase) ``;
exports.ContentHeader = (0, styled_1.default)('div') `
  width: 80%;
  height: ${SHIMMER_LINE_HEIGHT};
`;
exports.ContentText = (0, styled_1.default)('div') `
  > div {
    display: flex;
    margin-top: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
    justify-content: space-between;
    > div {
      width: 47%;
      height: 2rem;
    }
  }
`;
//# sourceMappingURL=styles.js.map